module.exports = __webpack_public_path__ + "static/media/delete.8b8b8ce5.svg";